export default function getStyle() {

  return {
    innerDiv: {
      paddingLeft: '0.7rem',
      paddingBottom: '0.5rem',
      textAlign: 'left',
      lineHeight: 1
    }
  };
};
